module.exports = __webpack_public_path__ + "static/img/Full-Body4.82378fa5.jpg";